import type { WebSocketDataChunk, WebSocketResponse } from '~/modules/apps';
import type { TemplateType, ProviderSource } from '~/types/template';
import type { EMakeWinnerScenario } from '../constants';
import type { IVariantType } from '~/modules/campaign';
import type { Campaign } from '~/types/graphql';

export enum EMakeWinnerStep {
  NONE = 0,
  SELECT_VARIANT = 1,
  GO_TO_GP_EDITOR = 2,
  APPLY_WINNER_ACTION = 3,
}

export enum EMakeWinnerOperator {
  IS = 'IS',
  IS_NOT = 'IS_NOT',
}

export enum EApplyWinnerAction {
  STOP_AND_REPUBLISH_PAGE = 'STOP_AND_REPUBLISH_PAGE',
  STOP_CAMPAIGN = 'STOP_CAMPAIGN',
  STOP_AND_MAKE_DEFAULT = 'STOP_AND_MAKE_DEFAULT',
  STOP_AND_ASSIGN_AS_DEFAULT = 'STOP_AND_ASSIGN_AS_DEFAULT',
}

export interface IApplyWinnerStepInfo {
  title: string;
  description: string;
  buttonLabel: string;
}

export interface IMakeWinnerScenarioRule {
  templateType: TemplateType;
  controlProviderSource: ProviderSource[];
  variantProviderSource: ProviderSource[];
  scenario: EMakeWinnerScenario;
  operator?: EMakeWinnerOperator;
}

export interface IVariantMetadata {
  variantId: string;
  variantType: IVariantType;
  providerSource: ProviderSource;
  templateType: TemplateType;
  templateSuffix?: string;
  isDefaultTemplate: boolean;
  isGPLandingAndArticle: boolean;
  themePageID?: string;
}

export interface IMakeWinnerMetadata {
  scenario?: EMakeWinnerScenario;
  campaign: Campaign;
  control: IVariantMetadata;
  variant: IVariantMetadata;
}

type WSMakeWinnerDataType = WebSocketDataChunk<{
  campaign_id: string;
  need_publish: boolean;
  theme_page_id: string;
  winner_template_suffix: string;
}>;
export type WSMakeWinnerResponse = WebSocketResponse<WSMakeWinnerDataType>;
